import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../shared/utils/re-base-data';
import { Location } from '@angular/common';
import { NavigationState } from '../../models/navigationState';
import { Utilities } from '../../../shared/utils/utilities';
import { LinkData } from '../../models/LinkData';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'bdo-process-not-available',
    templateUrl: './process-not-available.component.html',
    styleUrls: ['./process-not-available.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProcessNotAvailableComponent implements OnDestroy {

  public context: string;
  public link: string;
  public title: string;
  public linkData: LinkData;
  private subscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private location: Location
  ) {
    const currentState: NavigationState = Utilities.getStateOfCurrentRoute(this.location);
    this.context = currentState?.context;
    this.link = currentState?.link || ReBaseData.hrefContact;
    this.title = currentState?.process;
    this.subscription = this.translateService.stream('general.navigation.backToHomepage').subscribe({
      next: (value) => {
        this.linkData = {
          href: ReBaseData.hrefHomepage,
          linkName: value
        };
      }
    });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
